export default "__VITE_ASSET__71841d62__$_?nuxt_component=async__"